import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ApiBuildingPlansInspectorateConstants } from "../../constants/api-constants/api-building-plans-inspectorate.constants";
import { map } from "rxjs/operators";
let BuildingPlansInspectorateService = class BuildingPlansInspectorateService {
    http;
    constructor(http) {
        this.http = http;
    }
    verifyReferenceNumberObservable(params, expand) {
        const encodedExpand = encodeURIComponent(expand);
        return this.http.post(`${ApiBuildingPlansInspectorateConstants.URL}/${ApiBuildingPlansInspectorateConstants.FUNCTION_VERIFY_BPI_BPAMS_REFERENCE_NUMBER}?expand=${encodedExpand}`, params);
    }
    getApplicationSetPropertiesObservable(applicationId, params) {
        return this.http.post(`${ApiBuildingPlansInspectorateConstants.URL}/${applicationId}/${ApiBuildingPlansInspectorateConstants.FUNCTION_SET_PROPERTIES}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
BuildingPlansInspectorateService = __decorate([
    Injectable({
        providedIn: "root"
    })
], BuildingPlansInspectorateService);
export { BuildingPlansInspectorateService };
